import { render, staticRenderFns } from "./Flickity.vue?vue&type=template&id=98639534&"
import script from "./Flickity.vue?vue&type=script&lang=js&"
export * from "./Flickity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Flickity.vue"
export default component.exports